import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminOrderProductPaymentManagement';
import withAuth from '../../../common/WithAuth';
import OrderProductPaymentManagement from '../../../pages/Admin/OrderProductPaymentManagement/OrderProductPaymentManagement';

const mapStateToProps = (state) => ({
    listOrderProduct: state.adminOrderProductPaymentManagement.getAllOrder.data?.results,
    detailOrderProduct: state.adminOrderProductPaymentManagement.getDetailOrder.data?.data,
    isLoading: state.adminOrderProductPaymentManagement.getAllOrder.isFetching
    || state.adminOrderProductPaymentManagement.getDetailOrder.isFetching
    || state.adminOrderProductPaymentManagement.updateStatus.isFetching
    || state.adminOrderProductPaymentManagement.resentMail.isFetching,
    productPayment: state.adminOrderProductPaymentManagement.getAllOrder.data,
    detailPayment: state.adminOrderProductPaymentManagement.getDetailOrder.data,
    resentMailSuccess: state.adminOrderProductPaymentManagement.resentMail.isSuccess,
    updateStatusSuccess: state.adminOrderProductPaymentManagement.updateStatus.isSuccess,
    errorsResentMail: state.adminOrderProductPaymentManagement.resentMail.errors,
    errorsUpdateStatus: state.adminOrderProductPaymentManagement.updateStatus.errors,
});

const mapDispatchToProps = (dispatch) => ({
    getAllOrderProduct: (params) => {
        dispatch(Action.getAllOrderProductRequested(params));
    },
    getDetailOrderProduct: (params) => {
        dispatch(Action.getDetailOrderProductRequested(params));
    },
    clearAllOrderProduct: () => {
        dispatch(Action.clearOrderProductData());
    },
    clearDetailOrderProduct: () => {
        dispatch(Action.clearDetailOrderProductData());
    },
    updateStatusTransaction: (params) => {
        dispatch(Action.updateStatusTransactionRequested(params));
    },
    clearStatusData: () => {
        dispatch(Action.clearStatusTransaction());
    },
    resentMailOrder: (params) => {
        dispatch(Action.resentMailOrderRequested(params));
    },
    clearResentMailData: () => {
        dispatch(Action.clearMailOrder());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(OrderProductPaymentManagement);
